/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What data format does it accept?`)
};

const es_line_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué formato de datos acepta?`)
};

const de_line_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welches Datenformat wird akzeptiert?`)
};

const nl_line_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welk gegevensformaat accepteert het?`)
};

const fr_line_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel format de données accepte-t-il ?`)
};

const it_line_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che formato di dati accetta?`)
};

const pt_br2_line_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que formato de dados ele aceita?`)
};

const pt_line_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que formato de dados aceita?`)
};

const ja_line_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのようなデータ形式に対応していますか？`)
};

const zh_line_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受哪种数据格式？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_faq_q1", locale)
	if (locale === "en") return en_line_faq_q1(inputs)
	if (locale === "es") return es_line_faq_q1(inputs)
	if (locale === "de") return de_line_faq_q1(inputs)
	if (locale === "nl") return nl_line_faq_q1(inputs)
	if (locale === "fr") return fr_line_faq_q1(inputs)
	if (locale === "it") return it_line_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_line_faq_q1(inputs)
	if (locale === "pt") return pt_line_faq_q1(inputs)
	if (locale === "ja") return ja_line_faq_q1(inputs)
	return zh_line_faq_q1(inputs)
};